import { useQuery } from '@tanstack/react-query';
import { callApi } from './api';
import TelegramBotStats, { TelegramStatsPeriod } from '../models/telegram-bot-stats';

const statsApiUrl = import.meta.env.VITE_API_URL_V1 + '/admin/telegram-bot-stats';

export const getTelegramBotStats = async (period: TelegramStatsPeriod) => {
    return callApi<TelegramBotStats>({
        url: `${statsApiUrl}?period=${period}`,
        method: 'GET',
    });
};

export const useTelegramBotStats = (period: TelegramStatsPeriod) => {
    return useQuery({
        queryKey: ['telegram-bot-stats', period],
        queryFn: () => getTelegramBotStats(period),
        refetchOnWindowFocus: false,
    });
};
